// extracted by mini-css-extract-plugin
export default {"save-button":"SaveFilters_save-button__bAdvO"};